<fleet-dialog-layout
  [title]="'Change Phone Number'"
  [iconColour]="'primary'"
  [icon]="'warning'"
  [showCancel]="!hasPhonenumberChanged"
  >
  <div slot="main">
    @if (hasPhonenumberChanged) {
      <div class="text-lg">
        {{
        'Your phone number has changed to
        ' + phonenumberControl.value
        }}
      </div>
    } @else {
      @if (verification) {
        <ng-container slot="main">
          <div>
            We've sms'd a code {{ phonenumberControl.value }}
            Please check your phone and enter the code below
          </div>
          <div class="flex w-full m-auto p-8 justify-center">
            <mat-form-field class="w-full w-40">
              <input
                matInput
                placeholder="Enter code"
                [formControl]="codeControl"
                />
            </mat-form-field>
          </div>
        </ng-container>
      } @else {
        <mat-form-field class="w-full">
          <input
            matInput
            placeholder="New Phone Number"
            [formControl]="phonenumberControl"
            />
        </mat-form-field>
      }
    }

  </div>
  @for (alert of issues | alertsFromIssues; track alert) {
    <fuse-alert
      slot="error"
      class=""
      [appearance]="'outline'"
      [showIcon]="true"
      [type]="alert.type"
      [@shake]="alert.type === 'error'"
      >
      {{ alert.message }}
    </fuse-alert>
  }

  <ng-container slot="action">
    @if (!verification && !hasPhonenumberChanged) {
      <button
        [disabled]="!phonenumberControl.valid"
        mat-flat-button
        class="bg-primary-600 text-white disabled:bg-gray-200"
        (click)="begin()"
        >
        NEXT
      </button>
    }
    @if (verification && !hasPhonenumberChanged) {
      <fleet-progress-button
        [state]="{ buttonLabel: 'Verify', loading: loading }"
        [loading]="loading"
        (onClick)="verify()"
      ></fleet-progress-button>
    }
    @if (hasPhonenumberChanged) {
      <button
        class="bg-primary-600 text-white disabled:bg-gray-200"
        mat-flat-button
        [matDialogClose]
        >
        OK
      </button>
    }
  </ng-container>
</fleet-dialog-layout>
